import {
  BalanceUpdateRTM,
  BetCreatedRTM,
  BetProcessedRTM,
  DailyBonusClaimedRTM,
  PurchaseAndPaymentUpdateRTM,
  FriendshipRemovedRTM,
  KycVerificationUpdateRTM,
  OnboardingCompleteRTM,
  RakebackClaimedRTM,
  RedemptionAndPaymentUpdateRTM,
  ReferralBonusRewardedRTM,
  CasinoSettingUpdateRTM,
  WinCreatedRTM,
  BetAndWinCreatedRTM,
  PaymentProviderAccountApprovalUpdateRTM,
  GameRoundResolvedRTM,
  CurrencyUpdateRTM,
  BalanceAdjustmentUpdateRTM,
  PostalRequestCodeProcessedRTM,
  UserFeatureUpdatedRTM,
  UserNameUpdateRTM,
  BannedRTM,
  DocumentReviewRequestItemUpdateRTM,
  PurchasePackageUpdateRTM,
  PromotionUpdateRTM,
  PromotionStartedRTM,
  CountryModeUpdateRTM,
  StateModeUpdateRTM,
  StatePacksUpdateRTM,
  PacksOrderUpdateRTM,
  PacksInventoryUpdateRTM,
  PaymentMethodUpdateRTM,
  TopUpClaimedRTM,
  DocumentVerificationUpdateRTM,
  PlaythroughRequirementResetRTM,
  VipLevelUpRTM,
  VipLevelUpRewardClaimedRTM,
  VipWeeklyRewardClaimedRTM,
  CrmPopupRTM,
} from '../rtm/index.js';

export const ServerRTE = {
  Message: 'message',
  MessagesLoaded: 'messages_loaded',
  Notification: 'notification',
} as const;
export type ServerRTE = (typeof ServerRTE)[keyof typeof ServerRTE];

export const UserChannelRTE = {
  BalanceUpdate: 'balance_update',
  BetCreated: 'bet_created',
  WinCreated: 'win_created',
  BetProcessed: 'bet_processed',
  GameRoundResolved: 'game_round_resolved',
  BetAndWinCreated: 'bet_and_win_created',
  DailyBonusClaimed: 'daily_bonus_claimed',
  PurchaseAndPaymentUpdate: 'purchase_and_payment_update',
  KYCVerificationUpdate: 'kyc_verification_update',
  FriendshipRemoved: 'friendship_removed',
  RakebackClaimed: 'rakeback_claimed',
  RedemptionAndPaymentUpdate: 'redemption_and_payment_update',
  UserAvatarUpdate: 'user_avatar_update',
  UserNameUpdate: 'user_name_update',
  OnboardingComplete: 'onboarding_complete',
  ReferralBonusRewarded: 'referral_bonus_rewarded',
  PostalRequestCodeProcessed: 'postal_request_code_processed',
  UserFeatureUpdated: 'user_feature_updated',
  BalanceAdjustmentUpdate: 'balance_adjustment_update',
  PaymentProviderAccountApprovalUpdate: 'payment_provider_account_approval_update',
  PaymentMethodUpdate: 'payment_method_update',
  DocumentReviewRequestItemUpdate: 'document_review_request_item_update',
  Banned: 'banned',
  PurchasePackageUpdate: 'purchase_package_update',
  PromotionUpdate: 'promotion_update',
  TopUpClaimed: 'top_up_claimed',
  DocumentVerificationUpdate: 'document_verification_update',
  PlaythroughRequirementReset: 'playthrough_requirement_reset',
  VipLevelUp: 'vip_level_up',
  VipLevelUpRewardClaimed: 'vip_level_up_reward_claimed',
  VipWeeklyRewardClaimed: 'vip_weekly_reward_claimed',
  PacksOrderUpdate: 'packs_order_update',
  PacksInventoryUpdate: 'packs_inventory_update',
  CrmPopup: 'crm_popup',
} as const;
export type UserChannelRTE = (typeof UserChannelRTE)[keyof typeof UserChannelRTE];

export const GlobalRTE = {
  CasinoSettingUpdate: 'casino_setting_update',
  CountryModeUpdate: 'country_mode_update',
  CurrencyUpdate: 'currency_update',
  PromotionStarted: 'promotion_started',
  StateModeUpdate: 'state_mode_update',
  StatePacksUpdate: 'state_packs_update',
} as const;
export type GlobalRTE = (typeof GlobalRTE)[keyof typeof GlobalRTE];

export interface UserChannelRTEConfig {
  /**
   * @deprecated
   * Should no longer use this. Create a message type of the specific event instead.
   */
  [UserChannelRTE.BalanceUpdate]: BalanceUpdateRTM;

  [UserChannelRTE.BetCreated]: BetCreatedRTM;
  [UserChannelRTE.WinCreated]: WinCreatedRTM;
  [UserChannelRTE.BetAndWinCreated]: BetAndWinCreatedRTM;
  [UserChannelRTE.BetProcessed]: BetProcessedRTM;
  [UserChannelRTE.GameRoundResolved]: GameRoundResolvedRTM;
  [UserChannelRTE.DailyBonusClaimed]: DailyBonusClaimedRTM;
  [UserChannelRTE.PurchaseAndPaymentUpdate]: PurchaseAndPaymentUpdateRTM;
  [UserChannelRTE.FriendshipRemoved]: FriendshipRemovedRTM;
  [UserChannelRTE.KYCVerificationUpdate]: KycVerificationUpdateRTM;
  [UserChannelRTE.RakebackClaimed]: RakebackClaimedRTM;
  [UserChannelRTE.RedemptionAndPaymentUpdate]: RedemptionAndPaymentUpdateRTM;
  [UserChannelRTE.OnboardingComplete]: OnboardingCompleteRTM;
  [UserChannelRTE.UserAvatarUpdate]: { avatar_url: string };
  [UserChannelRTE.UserNameUpdate]: UserNameUpdateRTM;
  [UserChannelRTE.ReferralBonusRewarded]: ReferralBonusRewardedRTM;
  [UserChannelRTE.PostalRequestCodeProcessed]: PostalRequestCodeProcessedRTM;
  [UserChannelRTE.UserFeatureUpdated]: UserFeatureUpdatedRTM;
  [UserChannelRTE.BalanceAdjustmentUpdate]: BalanceAdjustmentUpdateRTM;
  [UserChannelRTE.PaymentProviderAccountApprovalUpdate]: PaymentProviderAccountApprovalUpdateRTM;
  [UserChannelRTE.DocumentReviewRequestItemUpdate]: DocumentReviewRequestItemUpdateRTM;
  [UserChannelRTE.Banned]: BannedRTM;
  [UserChannelRTE.PaymentMethodUpdate]: PaymentMethodUpdateRTM;
  [UserChannelRTE.PurchasePackageUpdate]: PurchasePackageUpdateRTM;
  [UserChannelRTE.PromotionUpdate]: PromotionUpdateRTM;
  [UserChannelRTE.TopUpClaimed]: TopUpClaimedRTM;
  [UserChannelRTE.DocumentVerificationUpdate]: DocumentVerificationUpdateRTM;
  [UserChannelRTE.PlaythroughRequirementReset]: PlaythroughRequirementResetRTM;
  [UserChannelRTE.VipLevelUp]: VipLevelUpRTM;
  [UserChannelRTE.VipLevelUpRewardClaimed]: VipLevelUpRewardClaimedRTM;
  [UserChannelRTE.VipWeeklyRewardClaimed]: VipWeeklyRewardClaimedRTM;
  [UserChannelRTE.PacksOrderUpdate]: PacksOrderUpdateRTM;
  [UserChannelRTE.PacksInventoryUpdate]: PacksInventoryUpdateRTM;
  [UserChannelRTE.CrmPopup]: CrmPopupRTM;
}

export interface GlobalRTEConfig {
  [GlobalRTE.CasinoSettingUpdate]: CasinoSettingUpdateRTM;
  [GlobalRTE.CountryModeUpdate]: CountryModeUpdateRTM;
  [GlobalRTE.CurrencyUpdate]: CurrencyUpdateRTM;
  [GlobalRTE.PromotionStarted]: PromotionStartedRTM;
  [GlobalRTE.StateModeUpdate]: StateModeUpdateRTM;
  [GlobalRTE.StatePacksUpdate]: StatePacksUpdateRTM;
}

export type ServerRTEConfig = UserChannelRTEConfig & {
  [ServerRTE.Message]: { user_id: string; text: string; room: string };
  [ServerRTE.MessagesLoaded]: Array<{ user_id: string; text: string; room_id: string }>;
  [ServerRTE.Notification]: any;
};
